module.exports = __webpack_public_path__ + "img/star-default.21937e90.svg";